import { render, staticRenderFns } from "./v-title.vue?vue&type=template&id=cfc29d90&scoped=true&"
import script from "./v-title.vue?vue&type=script&lang=js&"
export * from "./v-title.vue?vue&type=script&lang=js&"
import style0 from "./v-title.vue?vue&type=style&index=0&id=cfc29d90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc29d90",
  null
  
)

export default component.exports